import axios from 'axios';
import config from '@/config';
import { buildAxiosGetConfigWithRepeatedKey } from '@/features/common/utils/axiosQueryUtil';

const { iffApi } = config.ctx;

/**
 * 故障台账 API 服务
 */
export const faultService = {
  /** 获取故障统计（紧急数/一般数/本月已处理数） */
  getFaultStatistics: () => axios.get(`${iffApi}/fault/statistics`),

  /** 分页查询故障台账列表（statusList 多值时重复 query 参数 statusList=） */
  queryFaultPage: (inputParams = {}) =>
    axios.get(`${iffApi}/fault/page`, buildAxiosGetConfigWithRepeatedKey(inputParams, 'statusList')),

  /** 获取故障单详情 */
  getFaultDetail: (uuid) => axios.get(`${iffApi}/fault/detail/${uuid}`),

  /** 新增故障单 */
  saveFault: (data) => axios.post(`${iffApi}/fault/save`, data),

  /** 提交故障处置（self/defer） */
  handleFault: (data) => axios.post(`${iffApi}/fault/handle`, data),

  /** 导出故障台账 Excel */
  exportFault: (params) => axios.post(`${iffApi}/fault/exportExcel`, params, { responseType: 'blob' }),

  /** 故障单改派（管理平台正式改派，重置分配字段并清空小组委派） */
  reassignFault: (data) => axios.post(`${iffApi}/fault/reassign`, data),

  /** 批量改派故障单（支持当前筛选结果全选） */
  batchReassignFault: (data) => axios.post(`${iffApi}/fault/batchReassign`, data),

  // ==================== 上报甲方流程 ====================

  /** 保存上报信息草稿（不改状态） */
  saveReportDraft: (data) => axios.post(`${iffApi}/fault/report/saveDraft`, data),

  /** 预览上报 Word 文件（返回文件流） */
  previewReportFile: (data) => axios.post(`${iffApi}/fault/report/preview`, data, { responseType: 'blob' }),

  /** 正式下载并上报（锁定信息，状态变 REPORTED，返回文件流） */
  reportAndDownload: (data) => axios.post(`${iffApi}/fault/report/reportAndDownload`, data, { responseType: 'blob' }),

  /** 下载已上报文件（REPORTED/FIXED 状态，直接取已存档文件） */
  downloadReportedFile: (uuid) => axios.get(`${iffApi}/fault/report/getReportFile/${uuid}`, { responseType: 'blob' }),

  /** 完成维修结案（REPORTED → FIXED） */
  finishRepair: (data) => axios.post(`${iffApi}/fault/report/finishRepair`, data)
};
